import Enumeration from "./enumeration";

/**
 * List of choices attributes
 * @returns {Enumeration<statuses>}
 */
export const choicesAttributes = new Enumeration({
  ACKNOWLEDGED_SALES_CHANNEL: "acknowledgedSalesChannelsPrerequisites",
});
